import axios from 'axios'
import { push } from 'react-router-redux'
import { SubmissionError, reset, startSubmit, stopSubmit } from 'redux-form'
import { toastr } from 'react-redux-toastr'

import { getAuthToken } from '../utils/sessionStorage'
import config from '../config'
import { saveKeenEvent } from '../utils/KeenTracking'
import rollbar from '../utils/Rollbar'

export const CHANGE_LOGIN_BUTTON_MESSAGE = 'CHANGE_LOGIN_BUTTON_MESSAGE'
export const CHANGE_LOGIN_ERROR_MESSAGE = 'CHANGE_LOGIN_ERROR_MESSAGE'
export const LOGOUT = 'LOGOUT'
export const LOAD_DATA = 'LOAD_DATA'
export const LOAD_DATA_VIA_TOKEN = 'LOAD_DATA_VIA_TOKEN'
export const ADD_CAMPAIGN = 'ADD_CAMPAIGN'
export const UPDATE_CAMPAIGN = 'UPDATE_CAMPAIGN'
export const UPDATE_CAMPAIGN_NAME = 'UPDATE_CAMPAIGN_NAME'
export const ADD_VIDEO = 'ADD_VIDEO'
export const UPDATE_VIDEO = 'UPDATE_VIDEO'
export const SHOW_PASSWORD_SET_SUCCESS = 'SHOW_PASSWORD_SET_SUCCESS'
export const HIDE_MODAL_PASSWORD = 'HIDE_MODAL_PASSWORD'
export const CHANGE_ACTIVE_ACCOUNT = 'CHANGE_ACTIVE_ACCOUNT'
export const UPDATE_ACTIVE_ACCOUNT = 'UPDATE_ACTIVE_ACCOUNT'

// LOGIN

export function tryToLogin (user) {
  return (dispatch) => {
    dispatch(changeLoginButtonMessage('Carregando...'))
    doLogin(user)
      .then((payload) => {
        dispatch(loadData(payload.data))
        let person = {
          id: payload.data.id,
          name: payload.data.name,
          email: payload.data.email
        }
        rollbar.configure({
          payload: {
            person: person
          }
        })
        saveKeenEvent('login')
        dispatch(push('/campaigns'))
        dispatch(changeLoginButtonMessage('Acessar'))
      })
      .catch((error) => {
        rollbar.configure({
          payload: {
            person: {
              email: user.email
            }
          }
        })
        rollbar.error('Erro no login', error)
        dispatch(changeLoginButtonMessage('Acessar'))
        if (error.response) {
          dispatch(changeLoginErrorMessage(error.response.data.error))
        } else {
          dispatch(changeLoginErrorMessage('Ocorreu um erro. Tente novamente.'))
        }
      })
  }
}

export function logout () {
  return {
    type: LOGOUT
  }
}

export function loginViaToken (token, urlToGo) {
  return (dispatch) => {
    doLoginViaToken(token)
      .then((payload) => {
        dispatch(loadDataViaToken(payload.data))
        dispatch(push(urlToGo))
      })
  }
}

export function setPassword (passwordGroup, userId) {
  return (dispatch) => {
    dispatch(startSubmit('modalSetPassword'))
    if (!passwordGroup.password || !passwordGroup.password_confirmation) {
      dispatch(stopSubmit('modalSetPassword'))
      saveKeenEvent('tried-to-signup', { error: 'required' })
      throw new SubmissionError({ _error: 'Os campos de senha devem sem preenchidos. Verifique e tente novamente.' })
    } else if (passwordGroup.password !== passwordGroup.password_confirmation) {
      dispatch(stopSubmit('modalSetPassword'))
      saveKeenEvent('tried-to-signup', { error: 'unmatched_passwords' })
      throw new SubmissionError({ _error: 'As senhas digitadas não são iguais. Verifique e tente novamente.' })
    } else if (passwordGroup.password.length <= 8 || passwordGroup.password_confirmation <= 8) {
      dispatch(stopSubmit('modalSetPassword'))
      saveKeenEvent('tried-to-signup', { error: 'length_less_than_8' })
      throw new SubmissionError({ _error: 'Sua senha deve ter mais de 8 caracteres. Verifique e tente novamente.' })
    } else {
      doSetPassword(passwordGroup.password, userId)
        .then((res) => {
          if (res.statusText === 'Created') {
            dispatch(stopSubmit('modalSetPassword'))
            saveKeenEvent('signup')
            dispatch(showPasswordSetSuccess())
          } else {
            dispatch(stopSubmit('modalSetPassword'))
            throw new SubmissionError({ _error: 'Ocorreu um erro. Tente novamente.' })
          }
        })
        .catch((err) => {
          rollbar.error('Erro ao criar senha.', err)
          dispatch(stopSubmit('modalSetPassword'))
        })
    }
  }
}

export function hideModalPassword () {
  return {
    type: HIDE_MODAL_PASSWORD
  }
}

function changeLoginButtonMessage (message) {
  return {
    type: CHANGE_LOGIN_BUTTON_MESSAGE,
    message
  }
}

function changeLoginErrorMessage (message) {
  return {
    type: CHANGE_LOGIN_ERROR_MESSAGE,
    message
  }
}

function doLogin (user) {
  return axios({
    method: 'post',
    url: `${config.url}/users/sign_in`,
    data: {
      user
    }
  })
}

function doLoginViaToken (token) {
  return axios({
    method: 'post',
    url: `${config.url}/users/sign_in`,
    data: {
      user: {
        itk: token
      }
    }
  })
}

function showPasswordSetSuccess () {
  return {
    type: SHOW_PASSWORD_SET_SUCCESS
  }
}

function doSetPassword (password, userId) {
  return axios({
    method: 'put',
    url: `${config.url}/users/${userId}`,
    headers: {'X-User-Token': getAuthToken()},
    data: {
      user: {
        password
      }
    }
  })
}

// APP DATA

function loadData (payload) {
  return {
    type: LOAD_DATA,
    payload
  }
}

function loadDataViaToken (payload) {
  return {
    type: LOAD_DATA_VIA_TOKEN,
    payload
  }
}

// CAMPAIGN

export function addCampaign (campaign) {
  return (dispatch) => {
    sendCampaignToServer(campaign)
      .then((response) => {
        let campaign = response.data
        dispatch(doAddCampaign(campaign))
        dispatch(push('/campaigns'))
      })
  }
}

export function updateCampaign (campaign) {
  return (dispatch) => {
    updateCampaignOnServer(campaign)
      .then((response) => {
        dispatch(doUpdateCampaign(campaign))
      })
  }
}

export function doUpdateCampaign (campaign) {
  return {
    type: UPDATE_CAMPAIGN,
    campaign
  }
}

export function updateCampaignName (campaign) {
  return {
    type: UPDATE_CAMPAIGN_NAME,
    campaign
  }
}

function updateCampaignOnServer (campaign) {
  return axios({
    method: 'PUT',
    url: `${config.url}/campaigns/${campaign.id}`,
    headers: {'X-User-Token': getAuthToken()},
    data: {
      campaign
    }
  })
}

// VIDEO

export function addVideo (video, campaignId) {
  return (dispatch) => {
    sendVideoToServer(video, campaignId)
      .then((video) => {
        dispatch(doAddVideo(video, campaignId))
        dispatch(push(`/campaigns/${campaignId}/videos`))
      })
  }
}

export function addAlertToVideo (campaignId, video, alert) {
  return (dispatch) => {
    dispatch(startSubmit('newAlertForm'))
    addAlertToVideoOnServer(campaignId, video, alert)
      .then((res) => {
        dispatch(updateVideo(campaignId, video))
        toastr.success('Novo Alerta adicionado com sucesso.')
        dispatch(stopSubmit('newAlertForm'))
        dispatch(reset('newAlertForm'))
      })
      .catch((err) => {
        toastr.error('Ocorreu um erro ao adicionar novo alerta.', err.response.data.error)
        dispatch(stopSubmit('newAlertForm'))
      })
  }
}

function addAlertToVideoOnServer (campaignId, video, alert) {
  return axios({
    method: 'POST',
    url: `${config.url}/campaigns/${campaignId}/videos/${video.id}/play_alerts`,
    headers: {'X-User-Token': getAuthToken()},
    data: {
      play_alert: {
        name: alert.name,
        value: alert.value,
        recipients: alert.recipients
      }
    }
  })
}

export function addThumbToVideo (thumbnails, campaignId, videoId) {
  return (dispatch) => {
    axios({
      method: 'POST',
      url: `${config.url}/campaigns/${campaignId}/videos/${videoId}/thumbnails`,
      headers: {'X-User-Token': getAuthToken()},
      data: {
        thumbnails
      }
    })
      .then((res) => {
        let updatedVideo = res.data
        dispatch(updateVideo(campaignId, updatedVideo))
      })
  }
}

export function updateVideo (campaignId, video) {
  return {
    type: UPDATE_VIDEO,
    payload: {
      campaignId,
      video
    }
  }
}

// export function updateVideo (campaignId, video) {
//   return (dispatch) => {
//     dispatch(startSubmit('newAlertForm'))
//     updateVideoOnServer(campaignId, video)
//     .then((res) => {
//       dispatch(doUpdateVideo(campaignId, video))
//       toastr.success('Atualização feita com sucesso.')
//       dispatch(stopSubmit('newAlertForm'))
//       dispatch(reset('newAlertForm'))
//     })
//     .catch((err) => {
//       toastr.error('Ocorreu um erro.', err)
//       dispatch(stopSubmit('newAlertForm'))
//     })
//   }
// }

// function doUpdateVideo (campaignId, video) {
//   return {
//     type: UPDATE_VIDEO,
//     payload: {
//       campaignId,
//       video
//     }
//   }
// }

// function updateVideoOnServer (campaignId, video) {
//   return axios({
//     method: 'post',
//     url: `${config.url}/campaigns/`,
//     headers: {'X-User-Token': getAuthToken()},
//     data: {
//       campaignId,
//       video
//     }
//   })
// }

function doAddCampaign (campaign) {
  return {
    type: ADD_CAMPAIGN,
    campaign
  }
}

function doAddVideo (video, campaignId) {
  return {
    type: ADD_VIDEO,
    payload: { video, campaignId }
  }
}

function sendCampaignToServer (campaign) {
  return axios({
    method: 'post',
    url: `${config.url}/campaigns`,
    headers: {'X-User-Token': getAuthToken()},
    data: {
      campaign
    }
  })
}

function sendVideoToServer (video, campaignId) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      let videoId = Math.floor(Math.random() * 100).toString()
      resolve({
        ...video,
        id: videoId,
        thumbnail_url: '//placeholdit.imgix.net/~text?txtsize=33&txt=thumb&w=218&h=117'
      })
    }, 2000)
  })
}

// ACCOUNT

export function changeActiveAccount (id) {
  return (dispatch) => {
    dispatch(push('/campaigns'))
    dispatch(doChangeActiveAccount(id))
  }
}

function doChangeActiveAccount (id) {
  return {
    type: CHANGE_ACTIVE_ACCOUNT,
    id
  }
}

export function updateActiveAccount (campaign) {
  return {
    type: UPDATE_ACTIVE_ACCOUNT,
    campaign
  }
}



// WEBPACK FOOTER //
// ./src/actions/index.js